export default function ExperienceCoversheetIco() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="3.75" fill="#EBE1F9" />
      <path
        d="M12 16.6673V11.334"
        stroke="#7F56D9"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M8.66602 16.6667V14"
        stroke="#7F56D9"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M15.334 16.6667V8"
        stroke="#7F56D9"
        stroke-width="1.6"
        stroke-linecap="round"
      />
    </svg>
  );
}
